import { render, staticRenderFns } from "./KETHaendlerkontakte.vue?vue&type=template&id=e4c7412a&scoped=true&"
import script from "./KETHaendlerkontakte.vue?vue&type=script&lang=js&"
export * from "./KETHaendlerkontakte.vue?vue&type=script&lang=js&"
import style0 from "./KETHaendlerkontakte.vue?vue&type=style&index=0&id=e4c7412a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c7412a",
  null
  
)

export default component.exports